import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/mainMarketsCard.css';
import {getText} from '../../../../../../helpers/localization';
import Button from '../components/button';
import ImageLoader from 'react-load-image';
import {ASSETS_URL} from '../../../../../../constants/endpoints';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventId: state.vpp.selectedEventId,
        selectedEventIndex: state.vpp.selectedEventIndex,
        openBetsList: state.vpp.openBetsList,
        selectedChip: state.vpp.selectedChip
    };
};

class MainMarketsCard extends Component {
    constructor(props) {
        super(props);

        let store = props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        this.setState({
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip
        });
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = this.state.events[this.state.selectedEventIndex];
        let winDrawWinMarkets = selectedEvent.markets.filter(market => market.code === 9);
        let halfTimeResultMarkets = selectedEvent.markets.filter(market => market.code === 42);
        let correctScore = selectedEvent.markets.filter(market => market.code === 10);

        let awayTeamKit = selectedEvent.awayTeamKit.toString() === '0'
            ? 'Home'
            : 'Away';

        return (<div className={style.mainMarketsCardContainer}>
            <div className={style.titleContainer}>
                <div className={style.topBar}>
                    <div className={style.eventTitle}>{selectedEvent.title}</div>
                    <div className={style.eventPlace}>{selectedEvent.stadium}</div>
                </div>
                <div className={style.container}>
                    <div className={style.innerContainer}>
                        <div className={style.imageLoader}>
                            <ImageLoader
                                src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/${selectedEvent.teamOne}_Home.png`}>
                                <img
                                    src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/${selectedEvent.teamOne}_Home.png`}
                                    className={style.footballIcon} alt={`icon_${selectedEvent.teamOne}`}/>
                                <div>{''}</div>
                                <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={style.footballIcon}
                                     alt={`loading`}/>
                            </ImageLoader>
                        </div>
                        <div className={style.titleTableWrapper}>
                            <div className={style.title}>{selectedEvent.teamOne}</div>
                        </div>
                    </div>
                    <div className={`${style.innerContainer} ${style.odd}`}>
                        <div className={style.titleTableWrapper}>
                            <div className={style.title}>{getText('DRAW', this.props.store)}</div>
                        </div>
                    </div>
                    <div className={style.innerContainer}>
                        <div className={style.imageLoader}>
                            <ImageLoader
                                src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/${selectedEvent.teamTwo}_${awayTeamKit}.png`}>
                                <img
                                    src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/${selectedEvent.teamTwo}_${awayTeamKit}.png`}
                                    className={style.footballIcon} alt={`icon_${selectedEvent.teamOne}`}/>
                                <div>{''}</div>
                                <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={style.footballIcon}
                                     alt={`loading`}/>
                            </ImageLoader>
                        </div>
                        <div className={style.titleTableWrapper}>
                            <div className={style.title}>{selectedEvent.teamTwo}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={style.marketContainer}>
                <div className={style.topBar}>
                    <div className={style.marketTitle}>{getText('WIN_DRAW_WIN', this.props.store)}</div>
                </div>
                <div className={style.container}>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={winDrawWinMarkets.filter(m => m.num === 0)[0]}/>
                    <Button wrapperClass={`${style.innerContainer} ${style.odd}`} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={winDrawWinMarkets.filter(m => m.num === 1)[0]}/>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={winDrawWinMarkets.filter(m => m.num === 2)[0]}/>
                </div>
            </div>
            <div className={style.marketContainer}>
                <div className={style.topBar}>
                    <div className={style.marketTitle}>{getText('HALF_TIME_RESULT', this.props.store)}</div>
                </div>
                <div className={style.container}>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={halfTimeResultMarkets.filter(m => m.num === 0)[0]}/>
                    <Button wrapperClass={`${style.innerContainer} ${style.odd}`} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={halfTimeResultMarkets.filter(m => m.num === 1)[0]}/>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={halfTimeResultMarkets.filter(m => m.num === 2)[0]}/>
                </div>
            </div>
            <div className={`${style.marketContainer} ${style.correctScore}`}>
                <div className={style.topBar}>
                    <div className={style.marketTitle}>{getText('CORRECT_SCORE', this.props.store)}</div>
                </div>
                <div className={style.container}>
                    <div className={style.innerContainerColumn}>
                        <div className={style.row}>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 0)[0]}
                                    topText={correctScore.filter(m => m.num === 0)[0].selection}/>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 1)[0]}
                                    topText={correctScore.filter(m => m.num === 1)[0].selection}/>
                        </div>
                        <div className={style.row}>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 3)[0]}
                                    topText={correctScore.filter(m => m.num === 3)[0].selection}/>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 5)[0]}
                                    topText={correctScore.filter(m => m.num === 5)[0].selection}/>
                        </div>
                        <div className={style.row}>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 2)[0]}
                                    topText={correctScore.filter(m => m.num === 2)[0].selection}/>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 4)[0]}
                                    topText={correctScore.filter(m => m.num === 4)[0].selection}/>
                        </div>
                    </div>
                    <div className={`${style.innerContainerColumn} ${style.odd}`}>
                        <div className={style.row}>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 6)[0]}
                                    topText={correctScore.filter(m => m.num === 6)[0].selection}/>
                        </div>
                        <div className={style.row}>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 7)[0]}
                                    topText={correctScore.filter(m => m.num === 7)[0].selection}/>
                        </div>
                        <div className={style.row}>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 8)[0]}
                                    topText={correctScore.filter(m => m.num === 8)[0].selection}/>
                        </div>
                    </div>
                    <div className={style.innerContainerColumn}>
                        <div className={style.row}>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 9)[0]}
                                    topText={correctScore.filter(m => m.num === 9)[0].selection}/>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 10)[0]}
                                    topText={correctScore.filter(m => m.num === 10)[0].selection}/>
                        </div>
                        <div className={style.row}>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 12)[0]}
                                    topText={correctScore.filter(m => m.num === 12)[0].selection}/>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 14)[0]}
                                    topText={correctScore.filter(m => m.num === 14)[0].selection}/>
                        </div>
                        <div className={style.row}>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 11)[0]}
                                    topText={correctScore.filter(m => m.num === 11)[0].selection}/>
                            <Button wrapperClass={style.buttonWrapper} customButtonClass={style.buttonStyle}
                                    store={this.props.store} market={correctScore.filter(m => m.num === 13)[0]}
                                    topText={correctScore.filter(m => m.num === 13)[0].selection}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default connect(mapStateToProps)(MainMarketsCard);


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/desktop/modules/football/containers/mainMarketsCard.js